import { OdinController } from '@myosh/odin-components';
import type { Control } from 'react-hook-form';
import type { EmailThisButtonProps } from './email-this-button.component';
import EmailThisButton from './email-this-button.component';

interface HfEmailThisButtonProps extends EmailThisButtonProps {
  control?: Control;
  name?: string;
  hint?: string;
}

function HfEmailThisButton({ name = 'email_this_button', control, ...rest }: HfEmailThisButtonProps) {
  return <OdinController name={name} control={control} render={() => <EmailThisButton {...rest} />} />;
}

export default HfEmailThisButton;
